import { Instance } from 'mobx-state-tree';
import AirmarSensor from './model';

export interface IAirmarSensor extends Instance<typeof AirmarSensor> {}

export default AirmarSensor;
